(function(){
  if (!/\/apps\/subscriptions\/bb\//.test(location.pathname)) return;

  var PROTEIN_LABELS = ['Standard','Large (+2oz)','Double (+4oz)'];
  var CARB_LABELS    = ['Standard','Large (+2oz)','Double (+4oz)'];

  // Build the set of all expected labels: 'protein / carb' pairs
  function expectedLabelSet() {
    var set = {};
    for (var p = 0; p < PROTEIN_LABELS.length; p++) {
      for (var c = 0; c < CARB_LABELS.length; c++) {
        set[PROTEIN_LABELS[p] + ' / ' + CARB_LABELS[c]] = { p: p, c: c };
      }
    }
    return set;
  }
  var EXPECTED = expectedLabelSet();

  function findVariantSelect(card) {
    var selects = card.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var s = selects[i];
      if (s.classList.contains('gh-bab-protein') || s.classList.contains('gh-bab-carbs')) continue;
      if (s.options.length !== 9) continue;
      // Validate that all 9 options match the expected Standard/Large/Double x Standard/Large/Double set
      var matched = 0;
      for (var j = 0; j < s.options.length; j++) {
        if (EXPECTED.hasOwnProperty(s.options[j].textContent.trim())) matched++;
      }
      if (matched === 9) return s;
    }
    return null;
  }

  function makeSelect(cls, labels) {
    var sel = document.createElement('select');
    sel.className = cls + ' as-w-full as-p-2 as-border as-rounded';
    sel.style.cssText = 'width:100%;padding:6px 8px;border:1px solid #d1d5db;border-radius:6px;font-size:14px;background:#fff;';
    for (var i = 0; i < labels.length; i++) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = labels[i];
      sel.appendChild(o);
    }
    return sel;
  }

  function makeLabel(text) {
    var lbl = document.createElement('div');
    lbl.style.cssText = 'font-size:12px;font-weight:700;color:#111827;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.4px;';
    lbl.textContent = text;
    return lbl;
  }

  function injectInto(card) {
    if (card.dataset.ghBabDualInjected === '1') return;
    var origSelect = findVariantSelect(card);
    if (!origSelect) return;

    // Build a label -> option element lookup for fast variant ID retrieval
    var labelToOption = {};
    for (var i = 0; i < origSelect.options.length; i++) {
      labelToOption[origSelect.options[i].textContent.trim()] = origSelect.options[i];
    }

    origSelect.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.className = 'gh-bab-dual-options';
    wrap.style.cssText = 'display:flex;gap:10px;margin-top:8px;margin-bottom:8px;padding:0 12px;';

    var pCol = document.createElement('div'); pCol.style.flex = '1';
    var cCol = document.createElement('div'); cCol.style.flex = '1';

    var pSel = makeSelect('gh-bab-protein', PROTEIN_LABELS);
    var cSel = makeSelect('gh-bab-carbs', CARB_LABELS);

    pCol.appendChild(makeLabel('Protein'));
    pCol.appendChild(pSel);
    cCol.appendChild(makeLabel('Carbs'));
    cCol.appendChild(cSel);
    wrap.appendChild(pCol);
    wrap.appendChild(cCol);

    var insertTarget = origSelect.parentElement;
    insertTarget.parentElement.insertBefore(wrap, insertTarget);

    function sync() {
      var pIdx = parseInt(pSel.value, 10) || 0;
      var cIdx = parseInt(cSel.value, 10) || 0;
      var key = PROTEIN_LABELS[pIdx] + ' / ' + CARB_LABELS[cIdx];
      var targetOpt = labelToOption[key];
      if (!targetOpt) return;
      if (origSelect.value !== targetOpt.value) {
        origSelect.value = targetOpt.value;
        origSelect.dispatchEvent(new Event('change', { bubbles: true }));
        origSelect.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    pSel.addEventListener('change', sync);
    cSel.addEventListener('change', sync);

    // Initialize from current variant by reverse-lookup of the current selected label
    var curLabel = origSelect.options[origSelect.selectedIndex] ? origSelect.options[origSelect.selectedIndex].textContent.trim() : '';
    if (EXPECTED[curLabel]) {
      pSel.value = String(EXPECTED[curLabel].p);
      cSel.value = String(EXPECTED[curLabel].c);
    }

    card.dataset.ghBabDualInjected = '1';
  }

  function scan() {
    var cards = document.querySelectorAll('[class*="product-id-"]');
    for (var i = 0; i < cards.length; i++) injectInto(cards[i]);
  }

  var tries = 0;
  var interval = setInterval(function() {
    scan();
    tries++;
    if (tries > 40) clearInterval(interval);
  }, 500);

  var mo = new MutationObserver(function() { scan(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();